import { Box, Stack, Typography } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import Loading from 'assets/images/loading.png';
import { useContext } from 'react';
import { poppins300 } from 'theme/common.style';
import { welcomeBackLoader, welcomeLoader } from './Loader.style';
import { LoaderContext } from './LoaderContextProvider';

const CustomLoader = () => {
  const data1 = localStorage?.getItem('userDetail');
  const userDetail = data1 && JSON.parse(data1);
  const isFirstLogin = localStorage?.getItem('isFirstLogin');
  const isFirstLoginKey = JSON.parse(isFirstLogin);

  const { isLoadingPage, showUserName } = useContext(LoaderContext);

  return (
    <Dialog fullScreen open={isLoadingPage.isLoading}>
      <Box
        sx={{
          width: '100vw',
          height: '100vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 100000,
          position: 'absolute',
          top: 0,
          background: '#e7e6e6',
          overflow: 'hidden !important',
        }}
      >
        <Stack
          direction={'column'}
          gap={'20px'}
          justifyContent={'center'}
          alignItems={'center'}
        >
          {isLoadingPage.isLogin && showUserName && (
            <>
              <Typography sx={welcomeBackLoader}>
                {' '}
                {isFirstLoginKey == 0 ? 'Welcome back' : 'Welcome'},{' '}
                {userDetail?.userName} {userDetail?.userSurName}
              </Typography>
              <Typography sx={welcomeLoader}>
                We are preparing your workspace
              </Typography>
            </>
          )}
          <img
            alt="Logo"
            src={Loading}
            className="loaderImage"
            style={{ userSelect: 'none' }}
          />
          <Typography sx={{ ...poppins300, fontSize: '20px' }}>
            {isLoadingPage.isLogin ? 'Almost Done..' : ' Loading ...'}
          </Typography>
        </Stack>
      </Box>
    </Dialog>
  );
};
export default CustomLoader;
